<template>
  <div class="pallet-info">
    <basic-form
      ref="palletInfo"
      title="Pallet Info"
      :mode="FormModes.SPARSE"
      :form-params="whatToShow"
    >
      <template v-slot:actions>
        <el-button
          size="small"
          type="primary"
          plain
          :disabled="palletStatus === PalletDeleted"
          @click="editing = true"
          v-if="!editing && editable"
        >
          Edit
        </el-button>
        <el-button
          size="small"
          type="primary"
          plain
          @click="saveInfo"
          v-if="editing && editable"
        >
          Save
        </el-button>
        <el-button
          size="small"
          type="danger"
          plain
          @click="editing = false"
          v-if="editing && editable"
        >
          Cancel
        </el-button>
      </template>
    </basic-form>
    <confirm-dialog
      ref="confirm"
      title="Confirm Pallet Update"
      :confirmCb="confirmUpdate"
      :cancelCb="cancelCb"
      :width="50"
      :loading="updatingPallet"
    >
      <template v-slot:content>
        <div v-if="addressChanged" class="f-r-c-c address-warning">
          <svg-icon icon-class="warning" class="svg-danger-color" />
          <div class="hint-text bold-oswald">
            If address get changed, new pallet label needed!
          </div>
        </div>
        <div v-if="errMsg" class="f-r-c-c address-warning">
          <svg-icon icon-class="warning" class="svg-danger-color" />
          <div class="hint-text bold-oswald">
            {{ errMsg }}
          </div>
        </div>
        <basic-diff :tableData="diffsData" />
      </template>
    </confirm-dialog>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import * as T from '@/core/configs/types'
// msg
// import PagesMessage from '@/core/message/pages'
// apis
// import { modifyPallet } from '@/api/pallet'
// models
import {
  PalletDeleted,
  PalletInfoWrapUp,
  PalletInfoModifyForm,
  PalletTableHeaders
} from '@/core/models/pallet'
import { diffOfTwoObject } from '@/core/utils/common'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// components
import BasicForm from '@/components/common/BasicForm.vue'
import ConfirmDialog from '@/components/common/Confirm.vue'
import BasicDiff from '@/components/common/BasicDiff.vue'
import { modifyPallet } from '@/api/pallet'
import PagesMessage from '@/core/message/pages'
export default {
  name: 'PalletInfo',
  components: { BasicForm, ConfirmDialog, BasicDiff },
  mixins: [pageJumps],
  props: {
    palletId: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    pallet: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      PalletDeleted,
      FormModes: T.FormModes,
      updatingPallet: false,
      editing: false,
      diffs: [],
      errMsg: ''
    }
  },
  computed: {
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      const a = PalletInfoWrapUp(this.pallet)
      return a
    },
    editInfo() {
      const form = cloneDeep(PalletInfoModifyForm)
      Object.values(form).forEach(one => {
        one.value = this.pallet[one.key]
      })
      return form
    },
    diffsData() {
      const records = this.diffs.map(diff => {
        const header = PalletTableHeaders.find(one => one.key === diff.key)
        return {
          key: diff.key,
          label: header?.label ?? diff.key,
          oldValue: {
            type: header?.type ?? T.Text,
            value: diff.oldValue
          },
          newValue: {
            type: header?.type ?? T.Text,
            value: diff.newValue
          }
        }
      })
      return {
        records,
        total: this.diffs?.length ?? 0
      }
    },
    addressChanged() {
      return this.diffs.find(one => one.key === 'address')
    },
    palletStatus() {
      return this.pallet?.status ?? ''
    }
  },
  methods: {
    confirmUpdate() {
      if (this.diffs.length === 0) {
        this.errMsg = 'No Changes'
        return
      }
      const toSave = Object.fromEntries(
        this.diffs.map(one => [one.key, one.newValue])
      )
      toSave.addressId = toSave?.address?.id
      this.updatingPallet = true
      modifyPallet(this.palletId, toSave)
        .then(res => {
          this.$refs.confirm.close()
          this.$message.success('Update successfully!')
          this.editing = false
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_PALLET_DETAIL)
        })
        .catch(err => (this.errMsg = err))
        .finally(() => {
          this.updatingPallet = false
        })
    },
    cancelCb() {
      this.errMsg = ''
    },
    saveInfo() {
      const [passed, palletInfo] = this.$refs.palletInfo.validateAllInputs()
      if (passed) {
        const diffs = diffOfTwoObject(palletInfo, this.pallet)
        this.$set(this, 'diffs', diffs)
        this.$refs.confirm.open()
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.address-warning {
  padding: 0 10px;
  margin-bottom: 20px;

  svg {
    font-size: 24px;
    color: $deep-danger;
  }

  .hint-text {
    color: rgba($deep-danger, 1);
    margin-left: 20px;
    font-size: 18px;
    white-space: initial;
    word-break: break-word;
  }
}
</style>
